import styled from '@emotion/styled/macro'

const SearchResultItem = styled.div`
  padding: 22px 30px 22px 0;
  width: 160px;
  display: flex;
`

export default SearchResultItem
